import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { navLinks, brand } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[var(--line)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex flex-col leading-none">
            <span className="font-serif-display text-xl font-semibold tracking-tight">
              {brand.name}
            </span>
            <span className="text-[0.6rem] tracking-[0.32em] uppercase text-[var(--ivory)]/70 mt-1">
              Double Your Exports
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-9">
            {navLinks.map((l) =>
              l.route ? (
                <Link
                  key={l.href}
                  to={l.href}
                  className="text-sm text-[var(--ivory)]/80 hover:text-[var(--gold)] transition-colors duration-300"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-sm text-[var(--ivory)]/80 hover:text-[var(--gold)] transition-colors duration-300"
                >
                  {l.label}
                </a>
              )
            )}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="/#contact"
              className="btn-gold px-5 py-2.5 rounded-full text-sm inline-flex items-center gap-2"
            >
              <Phone size={15} /> Book a Call
            </a>
          </div>

          <button
            className="md:hidden text-[var(--ivory)]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-[var(--line)]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) =>
              l.route ? (
                <Link
                  key={l.href}
                  to={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base text-[var(--ivory)]/85 hover:text-[var(--gold)] transition-colors"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base text-[var(--ivory)]/85 hover:text-[var(--gold)] transition-colors"
                >
                  {l.label}
                </a>
              )
            )}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              className="btn-gold px-5 py-3 rounded-full text-sm inline-flex items-center justify-center gap-2"
            >
              <Phone size={15} /> Book a Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
